import { ButtonLoader } from './ButtonLoader';

export default ButtonLoader;
